import { cn } from "@/lib/utils";
import React from "react";

export const IconButton = React.forwardRef<
  React.ElementRef<"button">,
  React.ComponentPropsWithoutRef<"button">
>(({ className, children, ...props }, ref) => {
  return (
    <button
      ref={ref}
      type="button"
      className={cn([
        "h-5 w-5 cursor-pointer hover:scale-110 hover:text-primary bg-transparent border-none p-0",
        className,
      ])}
      {...props}
    >
      {children}
    </button>
  );
});

IconButton.displayName = "IconButton";
